import cn from 'classnames'

import { IBorderedButtonProps } from './bordered-button.props'
import styles from './styles.module.scss'

export default function BorderedButton({ children, onClick, className, ...props }: IBorderedButtonProps) {
  return (
    <button {...props} onClick={onClick} className={cn(styles.button, className)}>
      {children}
    </button>
  )
}
